module.exports = __webpack_public_path__ + "img/es-bottom.2b03ce0d.png";